@if (showSucesso === true) {
  <div class="body-alert-modal">
    <div class="div-alert text-center" style="width: 559px;height: 379px">
      <div class="div-botao-fechar">
        <button
          class="btn-icon"
          aria-label="Fechar"
          (click)="fechaSucesso()"
          >
          <i class="fa fa-times ci-gray fa-2x" aria-hidden="true"></i>
        </button>
      </div>
      <div class="div-alert-sucesso-padrao">
        <img src="/assets/img/sucesso-padrao.png" alt="Representando erro" width="90px">
        <h1>Sucesso!</h1>
        <p>{{descricaoSucesso}}</p>
        <button (click)="fechaSucesso()" id="fechaAlertaErro">FECHAR</button>
      </div>
    </div>
  </div>
}
